module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "cadastro-de-empreendimento formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.cadastrarCotaDeSubsidio.apply(null, arguments)
      }
    }
  }, [_c('h2', {
    staticClass: "titulo titulo_grande"
  }, [_vm._v("Preencha todos os campos obrigatórios abaixo para cadastrar uma cota de subsídio\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cotaDeSubsidio.ProjetoId),
      expression: "cotaDeSubsidio.ProjetoId"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cotaDeSubsidio, "ProjetoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.informarSobreProjetoQueNaoPodeTerCotas]
    }
  }, _vm._l((_vm.projetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.Id,
        "selected": projeto.Id === _vm.cotaDeSubsidio.ProjetoId ? 'selected' : ''
      }
    }, [_vm._v("\n              " + _vm._s(projeto.Nome) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cotaDeSubsidio.CidadeId),
      expression: "cotaDeSubsidio.CidadeId"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cotaDeSubsidio, "CidadeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.cidades), function(cidade) {
    return _c('option', {
      domProps: {
        "value": cidade.Id,
        "selected": cidade.Id === _vm.cotaDeSubsidio.CidadeId ? 'selected' : ''
      }
    }, [_vm._v("\n              " + _vm._s(cidade.Nome) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_1"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "totalDeCotas"
    }
  }, [_vm._v("Total de cotas disponibilizadas")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cotaDeSubsidio.Quantidade),
      expression: "cotaDeSubsidio.Quantidade"
    }],
    staticClass: "input uppercase",
    attrs: {
      "name": "totalDeCotas",
      "type": "number",
      "id": "totalDeCotas",
      "placeholder": "Ex: 100",
      "required": ""
    },
    domProps: {
      "value": (_vm.cotaDeSubsidio.Quantidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cotaDeSubsidio, "Quantidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.deveExibirBotoes) ? _c('div', {
    staticClass: "grade__linha"
  }, [_c('router-link', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    class: {
      'is-disabled': _vm.loading.visivel
    },
    attrs: {
      "to": {
        name: 'ListaDeCotas'
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar cota")])], 1) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('i', {
    staticClass: "fal fa-chart-network"
  }), _vm._v(" Dados do município\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-752ce68d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestao-de-cotas/CadastrarCota.vue
// module id = 1126
// module chunks = 1